module.exports = __webpack_public_path__ + "img/rafael-santos.0c7042ad.png";